import checkSiteConfig from "@api/checkSiteConfig";
import { useRouter } from "next/router";
import { useState } from "react";

export const useSiteConfig = () => {
  const router = useRouter();
  const [siteConfig, setSiteConfig] = useState({});

  const checkSiteSetting = async () => {
    const body = {
      modes: "Config",
      division: "store",
      channel:
        router.query.channel ||
        (sessionStorage.getItem("channelName") === "바로고" ? "BAROGO" : ""),
    };
    const res = await checkSiteConfig(body);
    if (res?.Code === "0000") {
      if (res.Data.channel.token) {
        sessionStorage.setItem("channel", res.Data.channel.token);
        sessionStorage.setItem("channelName", res.Data.channel.company);
        sessionStorage.setItem(
          "channelInfo",
          `${res.Data.channel.company ? res.Data.channel.company + "+" : ""}${
            res.Data.channel.regIdYn
          }`
        );
      }
      sessionStorage.setItem(
        "logo",
        JSON.stringify({
          pc: res.Data.channel.logo,
          mobile: res.Data.channel.mobile_logo,
        })
      );
      setSiteConfig(res.Data);
    }
  };

  return { siteConfig, checkSiteSetting };
};
